module.exports = __webpack_public_path__ + "img/area_7.b0d7482f.png";